import { Box } from '@withjoy/joykit';
import React, { forwardRef } from 'react';
import type { CurationHeroHeaderCurationHeader } from '../../CurationHeroHeader.types';
import { StyledBackgroundImage, StyledBackgroundVideo, StyledBackgroundVideoContainer, StyledGradient, styles } from './HeroBackground.styles';

type HeroBackgroundArgs = {
  curationHeader: CurationHeroHeaderCurationHeader;
  isSliderItem?: boolean;
  disableBackgroundGradient?: boolean;
  overrideBgImageUrl?: string;
};

const HeroBackground = forwardRef<HTMLIFrameElement, HeroBackgroundArgs>((props, ref) => {
  const { curationHeader, isSliderItem, disableBackgroundGradient = false, overrideBgImageUrl } = props;
  const { eyebrow, title, backgroundImage, video, videoThumbnail } = curationHeader;
  const bgImageUrl = overrideBgImageUrl ? overrideBgImageUrl : backgroundImage?.url;
  return (
    <Box __css={styles.mediaContainer}>
      <StyledGradient __css={styles.gradient(!isSliderItem, disableBackgroundGradient)} />
      {video && (
        <StyledBackgroundVideo __css={styles.backgroundVideo(videoThumbnail?.url)}>
          <StyledBackgroundVideoContainer __css={styles.backgroundVideoContainer}>
            <iframe
              ref={ref}
              src={`${video}&background=1`}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title={`${eyebrow}-${title}`}
            />
          </StyledBackgroundVideoContainer>
        </StyledBackgroundVideo>
      )}
      {!video && bgImageUrl && <StyledBackgroundImage __css={styles.backgroundImage(bgImageUrl)} />}
    </Box>
  );
});

export default HeroBackground;
